import { createSelector } from 'reselect';

const getTipoEstilo = (state) => state.layout.tipoEstilo;
const getLayoutViews = (state) => state.layout.views;
const getClienteActivo = (state) => state.theme.clienteActivo;
const getEstilosDeCliente = (state) => state.theme.estilosDeCliente;
const getViewName = (_, viewName) => viewName; // Para pasar el viewName como argumento

// Nuestro selector inteligente y componible
export const componerConfiguracion = () => createSelector(
  [getTipoEstilo, getLayoutViews, getClienteActivo, getEstilosDeCliente, getViewName],
  (tipoEstilo, layoutViews, clienteActivo, estilosDeCliente, vista) => {
    const layoutConfig = layoutViews[vista]?.[tipoEstilo] || {};
    const themeConfig = estilosDeCliente[clienteActivo] || {};

    const finalConfig = {
      ...layoutConfig, // Contiene transparentContainer, bigTitle, titulo
      palette: themeConfig.palette, // La paleta de colores del cliente
      /*estilos: {
        ...layoutConfig.estilos,
        boton: {
          ...themeConfig.components?.button,
          // ...layoutConfig.estilos?.boton
        },
        inputField: {
          ...themeConfig.components?.inputField,
        },
      },*/
    };
    
    return finalConfig;
  }
);